import { Stack } from '@mui/material';
import React from 'react';

class Props {
    pattern: string;
}
const Target = ({pattern} : Props) => {


    const getTextForTarget = (target: number, pattern: string) => {
          if (!pattern || pattern.length < target-1)
            return "";

        return pattern[target-1];

        let shotIdx = pattern.indexOf(target+"");

        if (shotIdx < 0)
            return "";
        return shotIdx+1;
    }

    const targets = [1,2,3,4,5];

    return <Stack direction={"row"} spacing={2}>
                {targets.map((x) => {
                    return <div style={{width:50, height: 50}} className='circle'>{getTextForTarget(x,pattern)}</div>
                })}
    </Stack>;
}

export default Target;